import { Trophy } from "lucide-react";
import { Money } from "@/components/common";
import { fmtDate } from "@/lib/format";

const MEDAL = ["bg-[#F2B880] text-[#0F382C]", "bg-slate-200 text-slate-700", "bg-orange-200 text-orange-800"];

export const CollectionLeaderboard = ({ data }) => (
  <div className="rounded-2xl border border-[#E7E2D6] bg-white p-5 shadow-sm lg:col-span-3" data-testid="collection-leaderboard">
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2 font-display text-lg font-semibold text-[#0F382C]"><Trophy className="h-5 w-5 text-[#D96B43]" />Collection leaderboard</div>
      <div className="text-xs text-muted-foreground">This week · since {fmtDate(data.since)}</div>
    </div>
    <div className="mt-4 space-y-2">
      {data.rows.length === 0 && <div className="text-sm text-muted-foreground">No delivery staff yet.</div>}
      {data.rows.map((r, i) => (
        <div key={r.name} className="flex items-center gap-3 rounded-xl bg-[#FBF9F4] px-3 py-2.5" data-testid={`leader-row-${i}`}>
          <div className={`grid h-8 w-8 shrink-0 place-items-center rounded-full font-mono text-sm font-bold ${MEDAL[i] || "bg-white text-slate-500 border"}`}>{i + 1}</div>
          <div className="min-w-0 flex-1"><div className="truncate font-semibold">{r.name}</div><div className="text-xs text-muted-foreground">{r.deliveries} deliveries</div></div>
          <div className="hidden sm:block text-right text-xs"><div className="text-muted-foreground">Cash</div><Money value={r.cash} /></div>
          <div className="hidden sm:block text-right text-xs"><div className="text-muted-foreground">UPI</div><Money value={r.upi} /></div>
          <div className="text-right"><div className="text-xs text-muted-foreground">Total</div><Money value={r.total} className="font-semibold text-[#0F382C]" testid={`leader-total-${i}`} /></div>
        </div>
      ))}
    </div>
  </div>
);
